import React from 'react';

import { useCan } from 'src/app/capabilities';
import type { Capability } from 'src/app/capabilities';

import { Forbidden } from './Forbidden';

/**
 * Route-level guard: renders `children` when the active property grants `right`,
 * otherwise a full-page Forbidden state. Wrap a section's route element with
 * this so a deep-link to a denied section shows a visible "no permission" state
 * instead of the page.
 */
export const RequireCapability: React.FC<{
  right: Capability;
  children: React.ReactNode;
}> = ({ right, children }) => {
  const allowed = useCan(right);
  return <>{allowed ? children : <Forbidden />}</>;
};
